import React, { useState } from "react";
import { FaUserAlt } from "react-icons/fa";
import ImagePopup from "./ImagePop";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

function DoctorTable({ doctors, onStatusChange }) {
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const navigate = useNavigate();

  const openImagePopup = (image) => {
    setImageUrl(image);
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setImageUrl(null);
    setShowImagePopup(false);
  };

  const toggleStatus = async (doctor) => {
    try {
      const updatedStatus = doctor.status === "active" ? "inactive" : "active";
      const response = await axiosInstance.put(`/doctors/${doctor.id}/status`, {
        status: updatedStatus,
      });

      if (response.status === 200) {
        onStatusChange(doctor.id, updatedStatus);
      } else {
        console.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error while updating status:", error);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg border border-gray-300 p-6 max-w-full">
      <div className="overflow-y-auto max-h-[500px]">
        <table className="min-w-full table-auto">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                #
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Image
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Doctor Name
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Qualification
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Description
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Department
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {doctors && doctors.length > 0 ? (
              doctors.map((doctor, index) => (
                <tr
                  key={doctor.id}
                  onClick={() =>
                    navigate(`/dashboard/doctors/${doctor.id}/schedule`)
                  }
                  className={`border-t hover:bg-blue-50 transition duration-150 cursor-pointer ${
                    doctor.status !== "active"
                      ? "bg-gray-100 text-gray-400"
                      : ""
                  }`}
                >
                  <td className="py-3 px-4 text-sm">{index + 1}</td>
                  <td
                    className="py-3 px-4 text-sm"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {doctor.image ? (
                      <img
                        src={doctor.image}
                        alt={doctor.name}
                        className="w-10 h-10 rounded-full object-cover cursor-pointer"
                        onClick={() => openImagePopup(doctor.image)}
                      />
                    ) : (
                      <FaUserAlt
                        className="w-8 h-8 text-gray-500 border-2 border-gray-300 rounded-full p-1 cursor-pointer"
                        onClick={() => openImagePopup(null)}
                      />
                    )}
                  </td>
                  <td className="py-3 px-4 text-sm">{doctor.name}</td>
                  <td className="py-3 px-4 text-sm">
                    {doctor.qualification || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-sm">
                    {doctor.description || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-sm">
                    {doctor.departmentName || "N/A"}
                  </td>

                  <td
                    className="py-3 px-4 text-sm"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={doctor.status === "active"}
                        onChange={(e) => {
                          e.stopPropagation();
                          toggleStatus(doctor);
                        }}
                        className="sr-only peer"
                      />
                      <div
                        className={`relative w-11 h-6 rounded-full transition ${
                          doctor.status === "active"
                            ? "bg-green-500"
                            : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 ${
                            doctor.status === "active" ? "translate-x-5" : ""
                          }`}
                        />
                      </div>
                    </label>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">
                  No doctors found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showImagePopup && (
        <ImagePopup imageUrl={imageUrl} onClose={closeImagePopup} />
      )}
    </div>
  );
}

export default DoctorTable;
